import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Ana Sayfa', href: '#hero' },
  { label: 'Odalar', href: '#odalar' },
  { label: 'Kahvaltı', href: '#kahvalti' },
  { label: 'Havuz', href: '#havuz' },
  { label: 'Konum', href: '#konum' },
  { label: 'Yorumlar', href: '#yorumlar' },
  { label: 'Fiyat Al', href: '#fiyat-form' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNav = (href: string) => {
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  const whatsappLink = 'https://wa.me/905395851199?text=' + encodeURIComponent(
    'Merhaba, İlkim Butik Otel hakkında bilgi almak istiyorum. Fiyat ve müsaitlik bilgisi alabilir miyim?'
  );

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#hero"
            onClick={(e) => {
              e.preventDefault();
              handleNav('#hero');
            }}
            className="flex items-center gap-2 shrink-0"
          >
            <img
              src="https://static.readdy.ai/image/63ce3e67fd2d5effcfb662b2683f46ed/914cdb8302f01f3f895c80f38cdb1f03.jpeg"
              alt="İlkim Butik Otel"
              className="h-10 md:h-12 w-auto object-contain"
            />
          </a>

          {/* Desktop links */}
          <div className="hidden md:flex items-center gap-1 lg:gap-2">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.href);
                }}
                className={`px-3 lg:px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                  scrolled
                    ? 'text-foreground-700 hover:text-primary-600 hover:bg-primary-50'
                    : 'text-white/90 hover:text-white hover:bg-white/10'
                }`}
              >
                {link.label}
              </a>
            ))}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block">
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              <i className="ri-whatsapp-line text-base" />
              Rezervasyon Sor
            </a>
          </div>

          {/* Mobile hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center rounded-full"
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="Menü"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-foreground-900' : 'text-white'}`} />
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div className={`md:hidden overflow-hidden transition-all duration-300 ease-out ${mobileOpen ? 'max-h-[400px] opacity-100' : 'max-h-0 opacity-0'}`}>
        <div className="bg-background-50/98 backdrop-blur-lg border-t border-background-200/60">
          <div className="px-4 py-4 space-y-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={(e) => {
                  e.preventDefault();
                  handleNav(link.href);
                }}
                className="block px-4 py-3 rounded-lg text-foreground-700 hover:text-primary-600 hover:bg-primary-50 text-sm font-medium"
              >
                {link.label}
              </a>
            ))}
            <a
              href={whatsappLink}
              target="_blank"
              rel="noopener noreferrer"
              className="block px-4 py-3 mt-2 bg-primary-500 text-background-50 rounded-full text-sm font-semibold text-center"
            >
              <i className="ri-whatsapp-line mr-2" />
              Rezervasyon Sor
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}